import AdminContentDuration from "./AdminContentDuration";

export default AdminContentDuration;
